export const sanitizeEventKey = (eventKey) =>
	String(eventKey ?? '')
		.trim()
		.replace(/\s+/g, '-');
